import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cellTemplate',
  standalone: true,
})
export class CellTemplatePipe implements PipeTransform {
  transform(cellTemplates: any[], field: string): any {
    const foundObject = cellTemplates?.find((obj: any) => obj.field === field);
    return foundObject ? foundObject.field : undefined;
  }
}
